import React from 'react';
import ProjectWiseExpenseReport from './ProjectWiseExpenseReport';
import './ProjectWiseExpenseReport.scss';

const ProjectWiseExpenseReportMain = () => (
  <div className="project-wise-expense-report-wrapper">
    <div className="project-wise-expense-report-content">
      <ProjectWiseExpenseReport />
    </div>
  </div>
);

export default ProjectWiseExpenseReportMain;
